import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommandRequestRecord } from '../services/device-command-scheduler.service';

@Component({
  selector: 'command-request-modal',
  templateUrl: './command-request-details-modal.component.html',
  styleUrls: ['./command-request-details-modal.component.scss']
})

export class CommandRequestDetailsModalComponent implements OnInit {
  commandRequest: CommandRequestRecord;
  commandRequestDetails: CommandRequestDetails;
  statusCss: string;

  loading: boolean = true;

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    this.loadData()
  }

  private loadData(): void {
    this.loading = true;
    try {
      this.commandRequestDetails = {
        id: this.commandRequest.commandRequestId,
        command: this.getCommandName(this.commandRequest.command),
        status: this.getStatusAndCss(this.commandRequest.status),
        deviceCount: this.commandRequest.deviceCount,
        requesterName: this.commandRequest.requesterName,
        description: this.commandRequest.description,
        requestedDate: formatDate(this.commandRequest.requestedDate, 'short', 'en-US'),
        inProgressSerialNumbers: this.commandRequest.inProgress?.join(", "),
        inProgressCount: this.commandRequest.inProgress.length,
        completeSerialNumbers: this.commandRequest.complete?.join(", "),
        completeCount: this.commandRequest.complete.length,
        errorSerialNumbers: this.commandRequest.error?.join(", "),
        errorCount: this.commandRequest.error.length
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  private getStatusAndCss(status: string): string {
    switch (status) {
      case 'IN_PROGRESS':
        this.statusCss = 'inProgress';
        return 'In Progress'
      case 'COMPLETE':
        this.statusCss = 'complete'
        return 'Complete'
      case 'ERROR':
        this.statusCss = 'error'
        return 'Error'
      case 'COMPLETE_WITH_ERRORS':
        this.statusCss = 'completeWithErrors'
        return 'Complete(but with Errors)'
      default:
        return undefined;
    }
  }

  private getCommandName(command: string): string {
    switch (command) {
      case 'checkIn':
        return 'Check In'
      case 'wake':
        return 'Wake'
      case 'settingsUpdate':
        return 'Sync Settings'
      case 'reboot':
        return 'Reboot'
      case 'forceUpdate':
        return 'Force Update'
      default:
        return undefined;
    }
  }
  close() {
    this.activeModal.close(false);
  }
}

export interface CommandRequestDetails {
  id: string,
  command: string,
  status: string,
  deviceCount: number,
  requesterName: string,
  description: string,
  requestedDate: string,
  inProgressSerialNumbers: string,
  inProgressCount: number,
  completeSerialNumbers: string,
  completeCount: number,
  errorSerialNumbers: string,
  errorCount: number
}


